import React from "react";

class OnBoardingSkip extends React.Component {
    render() {
        return (
            <div className="ob-sidebar-heading">
                <h5>Welcome to Social Walls</h5>
            </div>
        );
    }
}

export default OnBoardingSkip;
